<template lang="pug">
  #message_settings_page.container.page--message-settings
    .box.has-shadow(v-if="settings")
      .columns
        .column
          h3.title.has-text-left Message settings
        .column.is-narrow
          router-link.button.is-small.is-outlined(:to="{name: 'Messages'}")
            b-icon(icon="mail" size="is-small")
            span Back to messages

      .settings-block
        b-switch(
          :value="settings.messaging_enabled"
          @input="update({messaging_enabled: $event})"
        )
          strong Receive messages from my teachers
        p.help.has-text-grey
          | People you have shared lessons with can write to you on Teachee.

      .settings-block
        b-switch(
          :value="settings.message_emails_enabled"
          :disabled="!settings.messaging_enabled"
          @input="update({message_emails_enabled: $event})"
        )
          strong Email me when I get a new message

      .settings-block
        b-switch(
          :value="settings.allow_teacher_email_contact"
          :disabled="!settings.messaging_enabled"
          @input="update({allow_teacher_email_contact: $event})"
        )
          strong Let them reply to me by email
        //- Says what actually happens rather than "allow contact", which means
          nothing to the person deciding.
        p.help.has-text-grey
          | When this is on, our notification emails carry their real address —
          | and if you answer one by email, they will see your address and the
          | conversation continues outside Teachee. Turn it off to keep your
          | address private and answer only from Teachee.
        p.help.has-text-grey
          | Turning it off does not take back an address you have already
          | replied from.

      template(v-if="settings.blocked_users && settings.blocked_users.length")
        hr
        h4.subtitle.is-6.has-text-left Blocked people
        .valign.is-flex.mb-2(v-for="person in settings.blocked_users" :key="person.id")
          user-picture.mr-2(:user="person")
          span {{ person.first_name }} {{ person.last_name }}
          b-button.ml-auto.is-small.is-outlined(@click="unblock(person)")
            | Unblock

    b-loading(:active="!settings")
</template>


<script>
  import { mapGetters } from 'vuex'
  import UserPictureUI from '@/components/UserPictureUI'

  export default {
    name: 'MessageSettingsPage',
    components: {
      userPicture: UserPictureUI,
    },
    computed: {
      ...mapGetters(['messageSettings']),
      settings() {
        return this.messageSettings
      },
    },
    created() {
      this.$store.dispatch('setLayout', 'logged-in-layout')
    },
    mounted() {
      this.$store.dispatch('getMessageSettings')
    },
    methods: {
      update(change) {
        this.$store.dispatch('updateMessageSettings', change).then(() => {
          this.$buefy.toast.open({message: 'Saved', type: 'is-success'})
        }, () => {
          this.$buefy.toast.open({message: 'Could not save', type: 'is-danger'})
          this.$store.dispatch('getMessageSettings')
        })
      },
      unblock(person) {
        this.$store.dispatch('unblockUserFromMessaging', person.id).then(() => {
          this.$buefy.toast.open({message: `${person.first_name} can write to you again`, type: 'is-success'})
        })
      },
    },
  }
</script>


<style lang="scss">
  .page--message-settings {
    .settings-block {
      text-align: left;
      margin-bottom: 1.5rem;
    }

    .settings-block .help {
      margin-left: 3.5rem;
      max-width: 42rem;
    }
  }
</style>
